export const safeJsonParser = (entry) => {
	if (typeof entry === "object") {
		return entry;
	}
	try {
		return JSON.parse(entry);
	} catch {
		return null;
	}
};
